export default "__VITE_ASSET__BKrHRLFx__"